import React from 'react';
import { FaUsers, FaLeaf, FaThumbsUp, FaRocket, FaCheckCircle } from 'react-icons/fa';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaUsers />,
      title: "Expert Team",
      description: "Our professionals bring years of experience and dedication to every project.",
    },
    {
      icon: <FaLeaf />,
      title: "Sustainability Focus",
      description: "We prioritize environmentally friendly practices for a better future.",
    },
    {
      icon: <FaThumbsUp />,
      title: "Customer-Centric",
      description: "Your success is our mission. We tailor solutions to your unique needs.",
    },
    {
      icon: <FaCheckCircle />,
      title: "Proven Track Record",
      description: "A portfolio of successful projects trusted by clients across industries.",
    },
    {
      icon: <FaRocket />,
      title: "Innovation-Driven",
      description: "We embrace the latest technologies to deliver exceptional results.",
    },
  ];

  return (
    <section className="why-choose-us">
      <h2>Why Choose Us?</h2>
      <div className="reasons-grid">
        {reasons.map((item, index) => (
          <div className="reason-card" key={index}>
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
